/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Login container

Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Container, Row, Col } from "reactstrap";
import LoginForm from "../components/LoginForm";
export default function Login() {
	return (
		<div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
			<Container className="align-center ">
				<Row className="justify-content-center">
					<Col xs={5}>
						<LoginForm />
					</Col>
				</Row>
			</Container>
		</div>
	);
}
